import createSearchReducers from 'modules/global/reducers/simpleSearchReducer';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';

import * as types from 'modules/tags/actionTypes';
import { DASHBOARD_GROUP_SOURCE } from 'modules/tags/constants';

/** @typedef {import('modules/global/reducers/simpleSearchReducer').SimpleSearchReducer} TagsDashboardGroupReducer */

/**
 * @param {TagsDashboardGroupReducer} state
 * @param {DeleteTagSuccessAction} action
 */
const afterDeleteTagSuccess = (state, { payload: tagId }) => state.filter(id => id !== tagId);

/**
 * @param {import("modules/global/generic.types").Action<unknown>} action
 * @returns {boolean}
 */
const groupTagsMatcher = ({ meta = {} }) => meta.source === DASHBOARD_GROUP_SOURCE;

export default createSearchReducers(types.FETCH_TAGS, {
  ids: {
    [LOCATION_CHANGE]: () => [],
    [types.DELETE_TAG_SUCCESS]: afterDeleteTagSuccess,
  },
  global: { matcher: groupTagsMatcher, paginationSlice: true },
});
